import { FC } from 'react';
import { RetirementTab } from './Retirement.types';
import { Overview } from './tabs/Overview/Overview';
import { RetirementIncome } from './tabs/RetirementIncome/RetirementIncome';
import { MonteCarlo } from './tabs/MonteCarlo/MonteCarlo';
import { RothConversion } from './tabs/RothConversion/RothConversion';
import { Assumptions } from './tabs/Assumptions/Assumptions';

export const RETIREMENT_TAB_MAP: Record<RetirementTab, FC<any>> = {
  [RetirementTab.Overview]: Overview,
  [RetirementTab.RetirementIncome]: RetirementIncome,
  [RetirementTab.MonteCarlo]: MonteCarlo,
  [RetirementTab.RothConversion]: RothConversion,
  [RetirementTab.Assumptions]: Assumptions,
};
